import { Tooltip } from "antd";
import React from "react";
const CustomTooltip = ({ children, title = null, placement = "right", renderTooltip = true, }) => {
    return renderTooltip ? (React.createElement(Tooltip, { title: title, placement: placement }, children)) : (React.createElement(React.Fragment, null,
        " ",
        children));
};
export default CustomTooltip;
